// Copyright (c) 2016 Deere & Company

import FailurePanelContainer from './failure-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.parts.claim,
    downTimeCollection: state.claims.downTime,
    failureModes: state.claims.parts.failureModes,
    formValidation: state.claims.parts.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    installedBy: state.claims.parts.installedBy,
    isEditable: state.claims.parts.isEditable,
    isValidClaim: state.claims.parts.isValidClaim,
    partUseUnits: state.claims.partUseUnits
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FailurePanelContainer);



// WEBPACK FOOTER //
// ./src/claim/parts/components/failure-panel/index.js